// import axiosIns from '../utils/axios'
import { service as axiosIns } from '../utils/axios';
export const headerForm = {
    'content-type': 'application/x-www-form-urlencoded'
};

export const headerJson = {
    'content-type': 'application/json'
};

function getAppUser(key) {
    var user = sessionStorage.getItem('user')
    if(user) {
        try {
            return JSON.parse(user)[key]
        } catch(e) {
            console.log(e)
        }
    }
    return ''
}

/**
 * 会员接口
 * @param {*} data 
 */
export function memberIndex(data) {
    return axiosIns({
        url: '/memberinfo/member/getStaffMemberList',
        method: 'post',
        data
    })
}

// 获取会员列表
export function getStaffMemberList(data) {
    return axiosIns({
        url: '/memberinfo/member/v2/getStaffMemberList',
        method: 'post',
        data
    })
}


/**
 * 新的会员接口
 * @param {*} data 
 */
export function newMemberIndex(data) {
    return axiosIns({
        url: 'api/newMemberList',
        method: 'GET',
        data
    })
}

/**
 * 我服务的接口
 * @param {*} data 
 */
export function myService(data) {
    return axiosIns({
        url: 'api/myServiceList',
        method: 'GET',
        data
    })
}

/**
 * 会员主页
 */
export function memberHomePage(data){
    return axiosIns({
        url: 'api/memberHomePage',
        method: 'GET',
        data
    })
}



// WEBPACK FOOTER //
// ./src/api/member.js